import { AnalyticsEventTracker } from "src/app/nutrigenic/models/analytics-event-tracker.model";
import { v4 as uuidv4 } from 'uuid';

export class PurchaseEventTracker implements AnalyticsEventTracker {
  constructor(private eventName: string) {
    this.eventName = eventName;
  }

  getProcessedData(rawEventData: any) {
    if (!rawEventData) return;
    const event = {
      ecommerce: {
        transaction_id: rawEventData.ecommerce.transaction_id,
        value: rawEventData.ecommerce.value,
        currency: 'GBP',
        shipping: rawEventData.ecommerce.shipping,
        discount: rawEventData.ecommerce.discount,
        coupon: rawEventData.ecommerce.coupon,
        customer_info: rawEventData.ecommerce.customer_info,
        items: rawEventData.ecommerce.items
        /*currency: 'USD',
        transaction_id: this.generateTransactionId(),
        value: rawEventData.reduce(
          (accumulator: number, currentValue: any) =>
            accumulator + currentValue.value,
          0
        ),
        items: rawEventData.map((item: any) => ({
          item_id: item.id,
          item_name: item.title,
          item_category: item.category,
          quantity: Number(item.quantity),
          price: item.value,
        })),*/
      },
    };

    return {
      eventData: event,
    };
  }

  generateTransactionId(): string {
    return uuidv4();
  }
}
